import { createApi } from '../createApi';
import * as dummy from '../dummy/destinations';
import * as real from '../api/destinations';

const api = createApi(dummy, real);

/** 목적지/공통 데이터 서비스 — API_DOCS: 8. 공통 데이터 / 7. 가용성 / 21. 관리자 - 목적지 */
export const destinationService = {
  /* 서비스 (유저용) - 공통 데이터 */
  getAirports: api.getAirports,
  getGolfCourses: api.getGolfCourses,
  getSkiResorts: api.getSkiResorts,
  getHospitals: api.getHospitals,

  /* 서비스 (유저용) - 차량 및 버퍼 설정 */
  getBufferSettings: api.getBufferSettings,
  getVehicles: api.getVehicles,

  /* 서비스 - 가용성 */
  checkAvailability: api.checkAvailability,
  getAvailabilityCalendar: api.getAvailabilityCalendar,

  /* 관리자 - 골프장 CRUD */
  adminGetGolfCourses: api.getAdminGolfCourses,
  adminCreateGolfCourse: api.createAdminGolfCourse,
  adminUpdateGolfCourse: api.updateAdminGolfCourse,
  adminDeleteGolfCourse: api.deleteAdminGolfCourse,

  /* 관리자 - 스키장 CRUD (BugHerd #99 복원) */
  adminGetSkiResorts: api.getAdminSkiResorts,
  adminCreateSkiResort: api.createAdminSkiResort,
  adminUpdateSkiResort: api.updateAdminSkiResort,
  adminDeleteSkiResort: api.deleteAdminSkiResort,

  /* 관리자 - 병원 CRUD */
  adminGetHospitals: api.getAdminHospitals,
  adminCreateHospital: api.createAdminHospital,
  adminUpdateHospital: api.updateAdminHospital,
  adminDeleteHospital: api.deleteAdminHospital,

  /* 관리자 - 출발 지역 CRUD */
  adminGetDepartureRegions: api.getAdminDepartureRegions,
  adminCreateDepartureRegion: api.createAdminDepartureRegion,
  adminUpdateDepartureRegion: api.updateAdminDepartureRegion,
  adminDeleteDepartureRegion: api.deleteAdminDepartureRegion,

  /* 관리자 - 병원 지역 CRUD */
  adminGetHospitalRegions: api.getAdminHospitalRegions,
  adminCreateHospitalRegion: api.createAdminHospitalRegion,
  adminUpdateHospitalRegion: api.updateAdminHospitalRegion,
  adminDeleteHospitalRegion: api.deleteAdminHospitalRegion,
};
